import { useLocation } from '@umijs/max';
import React from 'react';
import { detailMenuConfigs } from '@/config/detailMenus';

interface DetailMenuAdapterProps {
  defaultDom: React.ReactNode;
}

const DetailMenuAdapter: React.FC<DetailMenuAdapterProps> = ({
  defaultDom,
}) => {
  const location = useLocation();
  const path = location.pathname;

  for (const config of detailMenuConfigs) {
    if (path.match(config.pattern)) {
      const Component = config.component;
      return <Component {...(config.props || {})} />;
    }
  }

  return <>{defaultDom}</>;
};

export default DetailMenuAdapter;
